/**
 * @file The label a contract control shows for a field a contract route's 400 names by its request-body path.
 * Failure path: an unknown field comes back unchanged, so the user still reads a name.
 */

const CONTRACT_PARTY_PATH = /^contactForContracts\[(\d+)\]\.(contactId|contractPartyDescription)$/;
const CHARGE_TEMPLATE_PATH_PREFIX = /^chargeTemplates\[\d+\]\./;

const FIELD_LABELS: { [field: string]: string } = {
  firstDate: "first-date",
  extensionDate: "first-date",
  expirationDate: "contract-expiration-date",
  referenceForTenant: "label-reference-for-tenant",
  mainTenantContactId: "label-tenant",
  note: "note",
  unitId: "dropdown-searchforunit-label"
};

const CHARGE_TEMPLATE_FIELD_LABELS: { [field: string]: string } = {
  type: "dialog/defaultchargetemplates-field/type-label",
  amount: "page/renewcontract-dialog/calculateprice-field/newamount-label",
  currencyId: "dialog/defaultchargetemplates-field/currency-label",
  repeatPeriodId: "dialog/defaultchargetemplates-field/period-label",
  description: "dialog/defaultchargetemplates-field/description-label",
  firstDate: "dialog/defaultchargetemplates-field/firstdate-label",
  endDate: "label/end-date",
  dueDateFirstPayment: "dialog/defaultchargetemplates-field/duedatefirstpayment-label",
  paymentRouteId: "dialog/defaultchargetemplates-field/paiddirectlytoowner-label",
  contactId: "label-contactid",
  companyId: "label-contactid"
};

export function getLabelForField(field: string, trans: (key: string) => string): string {
  if (field === "lastDate") {
    return `${trans("expiration-date")} 1`;
  }

  if (field === "finalRentalPeriodDate") {
    return `${trans("expiration-date")} 2`;
  }

  const contractParty = field.match(CONTRACT_PARTY_PATH);

  if (contractParty) {
    return getLabelForContractParty(parseInt(contractParty[1], 10), contractParty[2], trans);
  }

  const labelKey = CHARGE_TEMPLATE_PATH_PREFIX.test(field) ?
    CHARGE_TEMPLATE_FIELD_LABELS[field.replace(CHARGE_TEMPLATE_PATH_PREFIX, "")] :
    FIELD_LABELS[field];

  return labelKey ? trans(labelKey) : field;
}

function getLabelForContractParty(index: number, field: string, trans: (key: string) => string): string {
  if (field === "contractPartyDescription") {
    return trans("label-description");
  }

  return trans(index === 0 ? "label-tenant" : "dropdown-selectperson-label");
}
